
import Vue from "vue";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";
import {printLocalDateTime} from "@/utils/pretty-print";
export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		},
	},
	computed: {
		lastSaved(): string{
			return printLocalDateTime(this.state.recoverySale.LastModified);
		},
		lastSavedText(): string{
			return this.state.recoverySale.SaleID > 0 ? "last-saved" : "last-unsaved";
		},
		differenceInSale(): boolean{
			return this.state.sale != this.state.recoverySale.JsonData;
		}
	},
	methods: {
		async recover(){
			let builder = this.$confirmBuilder().setClass("warning").setWarningTitle().setMessage(this.$ct("confirm-recovery"));
			builder.setYesText(this.$ct("common.yes")).setNoText(this.$ct("common.cancel"));
			let confirm = await builder.show();
			if (confirm) {
				this.state.recoverSale();
			}
		}
	},
	mounted() {
		this.state.getRecoverySale();
	},
	i18nEx: {
		componentPrefix: "components.recovery-info"
	}
});
